import { navLinks } from '../data/nav';
import { author } from '../data/profile';
import type { Theme } from '../types';
import { ThemeToggle } from './ThemeToggle';
import './Nav.css';

interface NavProps {
  theme: Theme;
  onToggleTheme: () => void;
}

export function Nav({ theme, onToggleTheme }: NavProps) {
  return (
    <header className="nav">
      <a href="#top" className="nav-brand" aria-label={`${author.shortHandle} home`}>
        <span className="brand-mark">dq</span>
        <span className="brand-meta">
          <span>{author.shortHandle}</span>
          <span className="brand-meta-sub">v.2026</span>
        </span>
      </a>

      <nav className="nav-links" aria-label="Primary">
        {navLinks.map((link) => (
          <a key={link.href} href={link.href}>
            {link.label}
          </a>
        ))}
      </nav>

      <div className="nav-actions">
        <a
          className="status-pill"
          href={`mailto:${author.email}`}
          aria-label={`Available — email ${author.email}`}
        >
          <span className="status-dot" />
          Available
        </a>
        <ThemeToggle theme={theme} onToggle={onToggleTheme} />
      </div>
    </header>
  );
}
